export const PASSWORD_REGEX = /^(?=.*[A-Z])(?=.*[a-z])(?=.*\d)(?=.*[^A-Za-z0-9\s]).{8,}$/g;
export const FLOAT_REGEX = /^\d+(?:\.\d{1,2})?$/;
export const FLOAT_3_REGEX = /^\d+(?:\.\d{1,3})?$/;
export const FLOAT_4_REGEX = /^\d+(?:\.\d{1,4})?$/;
export const NUTRIENT_INFO_REGEX = /^((<|>|>=|<=)?(\d+(\.\d+)?))|(\d+(\.\d+)?-\d+(\.\d+)?)$/;
export const POTENCY_REGEX = /^(100(\.0{1,2})?|[1-9]\d?(\.\d{1,2})?)$/;
export const TEXT_REGEX = /^[A-Za-z'-]+(?: [A-Za-z'-]+)*$/;
export const ZIP_CODE_REGEX = /^[0-9]{5}(?:-[0-9]{4})?$/;
export const EMAIL_REGEX = /(\.[a-z]{2,})$/;
export const SIX_DIGIT_OTP_REGEX = /^\d{6}$/;
export const STRIPE_CARD_NAME_REGEX = /^[A-Za-z\s]+$/;
export const COST_REGEX = /^\$?(?:[0-9]{1,6})(?:\.[0-9]{1,2})?$/;
export const HEAVY_METAL_REGEX = /^(?:<=|>=|<|>)?\d+(?:\.\d+)?$/;
